import React from "react";
import CatelogueTable from "../tables/CatelogueTable";

function CatalogueList() {
  return (
    <div className={`white cover p-1`}>
      <h5 className=" mb-1 margin-0px">Auction Catalogue & Corrigendum</h5>
      <CatelogueTable />
    </div>
  );
}

export default CatalogueList;
